<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">{{ 'Missing an invoice'! | translate }}</h4>
</div>
<div class="modal-body">
  <form [formGroup]="formGroup" (ngSubmit)="onSubmit()">
    <div class="d-flex flex-column">
      <div>
        <strong>{{ 'Please enter the details below' | translate }}:</strong>
      </div>
      <div class="mt-3 w-100 form-group">
        <input
          class="form-control"
          type="text"
          [placeholder]="('Invoice number' | translate) + ' *'"
          formControlName="invoiceNumber"
        />
        <span
          class="text-danger"
          *ngIf="formGroup.get('invoiceNumber')?.invalid && formGroup.get('invoiceNumber')?.touched"
          >{{ 'Invoice number is required' | translate }}</span
        >
      </div>
      <div class="mt-3 w-100 form-group">
        <lib-datepicker-ngb-form-control
          ngDefaultControl
          [formControl]="$any(formGroup.controls['invoiceDate'])"
          [placeholder]="('Invoice date' | translate) + ' *'"
          [minDate]="null"
          [maxDate]="null"
          [inputClass]="'datepicker-input form-control'"
          [containerClass]="'datepicker-container d-flex flex-row align-items-center'"
          [faIconClass]="'datepicker-icon'"
        ></lib-datepicker-ngb-form-control>
        <span
          class="text-danger"
          *ngIf="formGroup.get('invoiceDate')?.invalid && formGroup.get('invoiceDate')?.touched"
          >{{ 'Invoice date is required' | translate }}</span
        >
      </div>
      <div class="mt-3 w-100 form-group">
        <input
          class="form-control"
          type="text"
          [placeholder]="('Customer' | translate) + ' *'"
          formControlName="customerName"
        />
        <span
          class="text-danger"
          *ngIf="formGroup.get('customerName')?.invalid && formGroup.get('customerName')?.touched"
          >{{ 'Customer is required' | translate }}</span
        >
      </div>
      <div class="mt-3 w-100 form-group">
        <input
          class="form-control"
          type="text"
          [placeholder]="('Product/ Part no.' | translate) + ' *'"
          formControlName="productNumber"
        />
        <span
          class="text-danger"
          *ngIf="formGroup.get('productNumber')?.invalid && formGroup.get('productNumber')?.touched"
          >{{ 'Product/ Part no. is required' | translate }}</span
        >
      </div>
      <div class="mt-3 w-100 form-group">
        <input
          class="form-control"
          type="text"
          [placeholder]="('Quantity of units' | translate) + ' *'"
          formControlName="quantityOfUnits"
        />
        <span
          class="text-danger"
          *ngIf="formGroup.get('quantityOfUnits')?.invalid && formGroup.get('quantityOfUnits')?.touched"
          >{{ 'Quantity of units is required' | translate }}</span
        >
      </div>
      <div class="mt-3 w-100 form-group">
        <app-custom-select-form-control
          [dataProvider]="(businessGroups$ | async)!"
          [labelField]="'value'"
          [valueField]="'key'"
          [placeholder]="('Business group' | translate) + ' *'"
          [formControlName]="'businessGroup'"
        ></app-custom-select-form-control>
        <span
          class="text-danger"
          *ngIf="formGroup.get('businessGroup')?.invalid && formGroup.get('businessGroup')?.touched"
          >{{ 'Business group is required' | translate }}</span
        >
      </div>
      <div class="mt-3 w-100 form-group">
        <label>{{ 'Attach PDF distributor’s invoice' | translate }}</label>
        <input class="form-control" type="file" accept="application/pdf" (change)="handleFileUpload($event)" />
      </div>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button class="btn btn-outline-primary" type="button" (click)="activeModal.close('cancel')">
    {{ 'Cancel' | translate }}
  </button>
  <button class="ms-sm-2 btn btn-primary" type="submit" (click)="onSubmit()">
    {{ 'Submit' | translate }}
  </button>
</div>
